import ReportView, { type ReportColumn, type ReportOption } from '../../../components/reports/ReportView';

const STATUS_OPTIONS: ReportOption[] = [
  { value: 'pending_signature', label: 'Pending Signature' },
  { value: 'signed', label: 'Signed' },
  { value: 'issued', label: 'Issued' },
  { value: 'voided', label: 'Voided' },
  { value: 'spoiled', label: 'Spoiled' },
];

const COLUMNS: ReportColumn[] = [
  { key: 'cheque_number', label: 'Cheque #' },
  { key: 'reference', label: 'Claim Reference' },
  { key: 'payee_name', label: 'Payee' },
  { key: 'amount', label: 'Amount', align: 'right', type: 'money' },
  { key: 'signatures', label: 'Signatures' },
  { key: 'status', label: 'Status' },
  { key: 'issued_at', label: 'Issued On' },
];

export function ChequeRegisterReport() {
  return (
    <ReportView
      title="Benefit Cheque Register"
      description="Every cheque issued against a benefit claim, with signature progress and status."
      endpoint="/reports/benefits/cheque-register"
      columns={COLUMNS}
      filters={['status', 'dateRange']}
      statusOptions={STATUS_OPTIONS}
    />
  );
}
